export default {
  account_id_required: "アカウントIDが必要です。",
  account_not_exists: "無効なパスワードです。",
  accountIdRequired: "セッションが期限切れです！続行するには再度ログインしてください...",
  agent_comm_rate_required: "エージェント手数料率が必要です。",
  agent_id_required: "エージェントIDが必要です。",
  alphaNumOnly: "英数字のみ",
  atLeastThreeMatchToBetParlay: "パーレイベットには最低3つの試合を選択してください。",
  atLeastTwoMatchToBetParlay: "パーレイベットには最低2つの試合を選択してください。",
  bet_amount_required: "ベット金額が必要です。",
  bet_id_required: "ベットIDが必要です。",
  betAmountRequired: "ベット金額が必要です。",
  betExists: "ベットはすでに存在します。",
  betLowerMin: "賭け金が最低賭け金を下回っています。",
  betNotExists: "トーナメントに参加するには有効なベットをしてください。",
  betOverMax: "賭け金が最大賭け金を超えています。",
  betOverMaxBet: "賭け金が最大賭け金を超えています。",
  betOverMaxPerMatch: "賭け金が最大賭け金を超えています。",
  betTypeRequired: "ベットタイプが必要です。",
  BLOCK: "アカウントがブロックされました！",
  changeStakeMax: "最大額の変更により、賭け金額が変更されました。",
  changeStakeMin: "最小額の変更により、賭け金額が変更されました。",
  CLOSE: "アカウントが閉鎖されました！",
  close: "アカウントが閉鎖されています！続行するには上位者に連絡してください...",
  confirmNewPasswordRequired: "新しいパスワードの確認が必要です！",
  connectionFailed: "ウォレットシステムのリンクに失敗しました。",
  containAlphaNum: "{fname}には少なくとも1つのアルファベットと1つの数字が必要です。",
  "createRoomFailed-1": "ルーム作成に失敗しました 1。",
  "createRoomFailed-2": "ルーム作成に失敗しました 2。",
  "createRoomFailed-3": "ルーム作成に失敗しました 3。",
  credit_amount_required: "クレジット金額が必要です。",
  currency_required: "通貨が必要です。",
  currencyNotSupported: "サポートされていない通貨です",
  currPasswordRequired: "現在のパスワードが必要です！",
  dataError: "データエラー",
  debit_amount_required: "デビット金額が必要です。",
  duplicate_credit_record: "重複したクレジットレコード。",
  duplicate_debit_record: "オッズが更新中です...",
  endDateRequired: "終了日が必要です！",
  EsportsDisabled: "E-スポーツゲームが無効です",
  forbiddenAccess: "アクセス禁止",
  FREEZE: "アカウントが凍結されました！",
  freeze: "アカウントが凍結されています！続行するには上位者に連絡してください...",
  game_maintenance: "ゲームはメンテナンス中です。",
  incompletedRequest: "何か問題が発生しました...",
  insufficient_balance: "残高が不足しています",
  invalid_password: "無効なパスワードです。",
  invalidBetAmount: "無効なベット金額です。",
  invalidBets: "このマーケットは利用できません。他のマーケットをお試しください。",
  invalidCurrency: "ベットに無効な通貨です。",
  invalidleague: "無効なリーグです。",
  invalidMarketType: "無効なマーケットタイプが提供されました。",
  invalidMatch: "無効な試合です。",
  invalidMember: "無効なメンバーです。",
  invalidOddsBall: "オッズが更新中です...",
  invalidOperator: "無効なオペレーターです。",
  invalidPassword: "無効なパスワードです",
  invalidRoom: "無効なルームです。",
  invalidRoomLimit: "無効なルーム制限です。",
  invalidRoomPassword: "無効なPINコードです。PINコードは6桁の数字である必要があります。",
  invalidRoomRate: "無効なルームレートです。",
  invalidRoomType: "無効なルームタイプです。",
  invalidRTSMatchOdds: "無効なRTSマッチオッズです。",
  invalidSession: "セッションが期限切れです！続行するには再度ログインしてください...",
  IPJoinedBefore: "このIPは以前に参加しています。",
  isAlpha: "{fname}はアルファベットのみ許可されます。",
  isAlphaNum: "{fname}は英数字のみ許可されます。",
  isEmail: "{fname}は有効なメールアドレスのみ許可されます。",
  isIpAddress: "{fname}は有効なIPv4アドレスのみ許可されます。",
  isMaxLength: "{fname}は最大{fvalue}文字以下である必要があります。",
  isMaxValue: "{fname}は最大{fvalue}以下である必要があります。",
  isMinLength: "{fname}は少なくとも{fvalue}文字以上である必要があります。",
  isMinValue: "{fname}は最低{fvalue}である必要があります。",
  isNumeric: "{fname}は数値のみ許可されます。",
  isOutrightRequired: "直撃が必要です！",
  // vuelidate
  isRequired: "{fname}を入力してください。",
  isSameAs: "{fname}は{fname2}と同じである必要があります。",
  isUrl: "{fname}はURLのみ許可されます。",
  "joinFailed-1": "ルーム参加に失敗しました 1。",
  "joinFailed-2": "ルーム参加に失敗しました 2。",
  leagueIdRequired: "リーグIDが必要です！",
  liveCasinoDisabled: "ライブカジノが無効です",
  liveMatchNotAllowed: "ライブマッチは許可されていません。",
  //tournament
  login_id_not_exists: "無効なログインです。再度ログインを試してください。",
  loginFailed: "ログインに失敗しました。後でもう一度お試しください...",
  loginLimit: "ログインの頻度が高すぎます。1分後に再試行してください...",
  lotteryDisabled: "宝くじが無効です",
  marketTypeChanged: "マーケットタイプの変更によりベットスリップが削除されました。<br />マーケットから再度選択してください。",
  marketTypeRequired: "マーケットタイプが必要です。",
  master_comm_rate_required: "マスター手数料率が必要です。",
  master_id_required: "マスターIDが必要です。",
  matchDateRequired: "試合日が必要です。",
  matchHide: "このマーケットは利用できません。他のマーケットをお試しください。",
  matchLowerMin: "試合の最低額エラーが発生しました。",
  matchNotActive: "この試合は利用できません。他の試合のマーケットをお試しください。",
  matchNotAllowBet: "このマーケットは利用できません。他のマーケットをお試しください。",
  matchOverMax: "試合の最大額エラーが発生しました。",
  matchRequired: "試合が必要です。",
  maxMatch: "最大{max}試合が選択されました！",
  maxParlayTicket: "パーレイの最大チケット数に達しました！",
  maxRoomLimit: "プレイヤー数は30以下である必要があります。",
  maxRoomRate: "エントリーフィーは1000以下である必要があります。",
  member_id_required: "メンバーIDが必要です。",
  member_wallet_not_exists: "メンバーウォレットが存在しません。",
  memberExists: "メンバーはすでに存在します。",
  memberJoinedBefore: "以前に参加したことがあります。無料のパブリックルームには1回しか参加できませんのでご注意ください。",
  minBetAmount: "最低ベット金額エラーが発生しました。",
  MiniGameDisabled: "ミニゲームが無効です",
  minMatch: "最低3つの試合を選択してください。",
  minRoomLimit: "プレイヤー数は3以上である必要があります。",
  minRoomRate: "エントリーフィーは10以上である必要があります。",
  new_login_id_exists: "無効なニックネームです。別のニックネームを設定してください。",
  newPasswordRequired: "新しいパスワードが必要です！",
  nickNameRequired: "ニックネームが必要です！",
  noMatchSelected: "少なくとも1つの試合を選択してください。",
  notSameAs: "{fname}と{fname2}は同じにすることはできません。",
  NoUserAccessRight: "許可が拒否されました！続行するには上位者に連絡してください...",
  oddsDisplayInvalid: "オッズが更新中です...",
  oddsIsUpdating: "オッズが更新中です...",
  OK: "OK",
  pageNumberRequired: "ページ番号が必要です！",
  pageSizeRequired: "ページサイズが必要です！",
  passwordRequired: "パスワードが必要です！",
  passwordsNotMatch: "パスワードが一致しません！",
  permission_denied: "許可が拒否されました。",
  pointsOverLimit: "ポイントが上限を超えています。",
  rate_required: "レートが必要です。",
  rateLowerMin: "レートが最低額を下回っています。",
  rateOverMax: "レートが上限を超えています。",
  requestFailed: "接続が不安定です。接続を確認してもう一度お試しください。",
  requestLimit: "リクエストの頻度が高すぎます。",
  requestPending: "リクエスト保留中...",
  result_exists: "結果はすでに存在します。",
  room_id_required: "ルームIDが必要です。",
  roomClosed: "ルームが閉鎖されています。",
  roomClosedNotAllowed: "ルームの閉鎖は許可されていません。",
  roomEnded: "ルームはすでに終了しています。",
  roomEndedOrCancelled: "ルームは終了またはキャンセルされました。",
  roomExists: "1つ以上のプライベートルームを作成することは許可されていません。",
  RoomExists: "1つ以上のプライベートルームを作成することは許可されていません。",
  roomFull: "ルームはすでに満員です。",
  roomIdRequired: "ルームIDが必要です。",
  roomIsPublicFree: "ルームは無料公開されています。",
  roomLimitLowerMin: "ルーム制限が最低額を下回っています。",
  roomLimitOverMax: "ルーム制限が上限を超えています。",
  roomLimitRequired: "ルーム制限が必要です。",
  roomNotExists: "ルームが存在しません。",
  roomOverMax: "ルームが上限を超えています。",
  roomPasswordRequired: "PINコードが必要です。",
  roomRateRequired: "ルームレートが必要です。",
  roomTypeRequired: "ルームタイプが必要です。",
  s_senior_comm_rate_required: "スーパースシニア手数料率が必要です。",
  s_senior_id_required: "スーパースシニアIDが必要です。",
  secondary_account_exists: "ニックネームはすでに作成されています。",
  selectLeague: "少なくとも1つのリーグを選択してください。",
  selectOption: "{fname}を選択してください。",
  senior_comm_rate_required: "シニア手数料率が必要です。",
  senior_id_required: "シニアIDが必要です。",
  session_expired: "セッションが期限切れです！続行するには再度ログインしてください...",
  session_not_exists: "セッションが期限切れです！続行するには再度ログインしてください...",
  sessionTokenRequired: "セッショントークンが必要です。",
  shareholder_comm_rate_required: "株主手数料率が必要です。",
  shareholder_id_required: "株主IDが必要です。",
  slotDisabled: "スロットが無効です",
  sportsTypeRequired: "スポーツタイプが必要です！",
  startDateRequired: "開始日が必要です！",
  SUSPEND: "アカウントが表示専用に変更されました。",
  suspend: "アカウントが停止されています！続行するには上位者に連絡してください...",
  systemError: "内部システムエラー。",
  tournamentDisabled: "トーナメントは無効です。上位者に確認してください。",
  tournamentLeagueExists: "トーナメントリーグが存在します。",
  tournamentMatchExists: "トーナメントマッチが存在します。",
  transfer_id_required: "振替IDが必要です。",
  unableToGetBalanceAtTheMoment: "内部サーバーエラー。",
  usernameRequired: "ユーザー名が必要です！",
  workingDateRequired: "作業日が必要です！",
  matchNotStarted: "試合がまだ始まっていません。",
  cashOutUnavailable: "キャッシュアウトが利用できません。",
  errorCashoutAmount: "キャッシュアウトが更新中です...",
  invalidParameter: "無効なパラメーターです。",
  startTimeRequired: "開始時間が必要です。",
  endTimeRequired: "終了時間が必要です。",
  oddsTypeIDRequired: "オッズタイプが必要です。",
  commissionRequired: "コミッションが必要です。",
  requestTimeRequired: "リクエスト時間が必要です。",
  statusRequired: "ステータスが必要です。",
  invalidStartTime: "開始時間が無効です。",
  invalidEndTime: "終了時間が無効です。",
  invalidOddsTypeID: "オッズタイプが無効です。",
  invalidCommission: "コミッションが無効です。",
  invalidRequestTime: "リクエスト時間が無効です。",
  invalidStatus: "ステータスが無効です。",
  invalidAlgoMatchInfo: "このマーケットは利用できません。他のマーケットをお試しください。",
  invalidAlgoSliderLeagueInfo: "無効なリーグ情報です。",
  invalidAlgoSliderMinutesWeight: "無効な分鐘重みです。",
  invalidAlgoSliderBetType: "無効なベットタイプです。",
  invalidRTSRunningScoreDetails: "無効なRTSスコア詳細です。",
  invalidProviderGoalTimeLine: "無効なプロバイダーゴール時間ラインです。",
  invalidSliderTimeRange: "無効なスライダー時間範囲です。",
  invalidMOMatchOdds: "マッチオッズが更新中です...",
  invalidProviderSlider: "無効なプロバイダースライダーです。",
  invalidCombineBetTypeAndOddsFormat: "無効な組み合わせベットタイプとオッズ形式です。",
  invalidMatchInformation: "無効なマッチ情報です。",
  marketClose: "この市場は閉鎖されています。他の市場をお試しください。",
  error: "エラー",
  freeRoomNeedBet: "無料ルームへのアクセスを解除するには、有効なベットをしてください。",
};
